export default __webpack_public_path__ + "static/media/ss8.0a112ca5.jpg";